module.exports = __webpack_public_path__ + "static/media/image23.bb10e43b.png";